import TrainingArchiveItem from './TrainingArchiveItem';

export default TrainingArchiveItem;
